<template>
	<div class="login-content">
		<div class="login-area">
			<h3 class="login-title">科技兔编程学院</h3>
			<el-form ref="loginForm" :model="form">
				<div class="form-error">
					<div class="error-msg" v-show="errorMsg"><i class="iconfont icon-error"></i>{{errorMsg}}</div>
				</div>
				<el-form-item prop="username">
					<el-input v-model="form.username" placeholder="请输入用户名" prefix-icon="iconfont icon-user"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input v-model="form.password" :type="showPwd?'text':'password'" placeholder="请输入密码"
						prefix-icon="iconfont icon-pwd">
						<i slot="suffix" class="iconfont iconfont-pwd" :class="showPwd?'icon-pwd-show':'icon-pwd-hide'"
							@click="showPwd =! showPwd"></i>
					</el-input>
				</el-form-item>
				<el-form-item prop="code" class="form-code">
					<el-input v-model="form.code" placeholder="请输入验证码" prefix-icon="iconfont icon-code"
						@keyup.enter.native="onSubmit()"></el-input>
					<el-image v-if="codeUrl" :src="codeUrl" @click="getCode" />
				</el-form-item>
				<el-form-item class="save-pwd">
					<el-checkbox v-model="savePwd" @change="isSave">记住账号密码</el-checkbox>
				</el-form-item>
				<el-form-item class="submit-item">
					<el-button class="submit-btn" type="primary" :loading="loading" @click="onSubmit()">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
    <div style="color: white;position: absolute;bottom: 10px;right: 10px">版本号：V{{currentVersion}}</div>
	</div>
</template>

<script>
  import config from '../../../package.json'
	import { getLoginCode } from '@/api/login';
	export default {
		name: "Login",
		data() {
			return {
				form: {
					username: "",
					password: "",
					code: "",
				},
				savePwd: false, // 是否记住密码
				loading: false,
				idenCode: "", //图形验证码
				showPwd: false, // 显示密码
				codeUrl: null,
        codeId: null,
				r: null,
        currentVersion: config.version,
				errorMsg: "", // 错误提示
			}
		},
		created() {
		  this.getModule()
			this.r = this.randomString(8);
		},
		mounted() {
			let savePwd = localStorage.getItem("save-pwd");
			if(savePwd === 'true'){
        this.savePwd = true
        this.setRememberLoginInfo()
      }
			this.getCode();
		},
		watch: {
			idenCode() {
				this.form.code = this.idenCode;
			},
		},
		methods: {
			async getCode() {
				const that = this
				let res = await getLoginCode({ r: that.r });
        that.codeUrl = res.data.img
        that.codeId = res.data.key
				// if(res.status == 200){
				// 	const blob = new Blob([res.data], { type: 'png' });
				// 	const fileReader = new FileReader()
				// 	fileReader.readAsDataURL(blob)
				// 	fileReader.onloadend = (e) => {
				// 		that.codeUrl = e.target.result;
				// 	}
				// }
			},
			onSubmit() { // 提交登录表单
				if (this.verificationForm()) {
					this.errorMsg = "";
					this.loading = true;
					this.form.codeId = this.codeId;
          this.form.clientVersion = this.currentVersion
					this.$store.dispatch("user/login", this.form).then((res) => {
						// // 登录成功保存账号密码
						if(this.savePwd){
							this.rememberLoginInfo()
						} else {
							localStorage.removeItem("user-account");
						}
						this.$router.push({ path: "/simulationGame" });
						this.$message.success("登录成功");
						this.loading = false;
					}).catch((error) => {
						this.loading = false;
            this.getCode()
					})
				}
			},
			verificationForm() {
				let userInfo = this.form;
				if (!userInfo.username) {
					this.errorMsg = "用户名不能为空";
					return false;
				}
				if (!userInfo.password) {
					this.errorMsg = "密码不能为空";
					return false;
				}
				if (!userInfo.code) {
					this.errorMsg = "验证码不能为空";
					return false;
				}
				if (!/^[0-9a-zA-Z]{4}$/.test(userInfo.code)) {
					this.errorMsg = "请输入4位有效的验证码";
					return false;
				}
				return true;
			},
			randomString(e) {
				e = e || 32
				const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
				const a = t.length
				let n = ''
				for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
				return n
			},
      rememberLoginInfo() {
        localStorage.setItem("save-pwd", true);
        console.log(this.form)
        localStorage.setItem("user-account", JSON.stringify({
          username: this.form.username,
          password: this.form.password
        }))
      },
      setRememberLoginInfo() {
        let loginInfo = localStorage.getItem('user-account')
        if(loginInfo) {
          loginInfo = JSON.parse(loginInfo)
          this.form.username = loginInfo.username
          this.form.password = loginInfo.password
        }
      },
      isSave() {
			  console.log(this.savePwd)
        localStorage.setItem("save-pwd", this.savePwd);
      },
      async compileStreaming(filename) {
        const response = await fetch(filename);
        return WebAssembly.compile(await response.arrayBuffer());
      },
      async getModule() {
        window.moduleCache = {}
        if(this.$isElectron()) {
          window.moduleCache["clang"] = await this.compileStreaming("game://./game/clang/clang");
          window.moduleCache["lld"] = await this.compileStreaming("game://./game/clang/lld");
        }else{
          window.moduleCache["clang"] = await this.compileStreaming("https://program-school.oss-cn-beijing.aliyuncs.com/game/static-v5/clang/clang");
          window.moduleCache["lld"] = await this.compileStreaming("https://program-school.oss-cn-beijing.aliyuncs.com/game/static-v5/clang/lld");
        }

      }
		}
	}
</script>

<style lang="scss">
$bg:#2d3a4b;
$cursor: #606266;
	.login-content {
		width: 100%;
		height: 100%;
		position: relative;
		background: url(~@/assets/img/loginBg.png) no-repeat;
		background-size: 100% 100%;

		.login-area {
			width: 33.44rem;
			height: 22.8rem;
			background: url(~@/assets/img/loginBox.png) no-repeat;
			background-size: 100% 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -55%);


			.login-title {
				font-size: 1.44rem;
				font-weight: 500;
				color: #00E5FF;
				text-align: center;
				margin-top: 0.72rem;
			}

			.el-form {
				padding: 1.68rem 5.4rem;

				.form-error {
					width: 100%;
					height: 1.68rem;
					margin-bottom: 0.4rem;

					.error-msg {
						line-height: 1.68rem;
						background: #FFFAF9;
						border: 1px solid #FF5959;
						border-radius: 0.2rem;
						font-size: 0.64rem;
						font-weight: bold;
						color: #D90B0B;

						.icon-error {
							margin: 0 0.4rem 0 0.76rem;
							font-size: 0.8rem;
							position: relative;
							top: 0.08rem;
						}
					}
				}

				.el-form-item {
					background: url(~@/assets/img/inputBox.png) no-repeat;
					background-size: 100% 100%;
					height: 2.72rem;

					.el-input input {
						background: none;
						border: none;
						height: 2.48rem;
						font-size: 0.84rem;
						font-weight: 500;
						color: #FFF;
						padding: 0 0 0 2.2rem;
            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus,
            &:-webkit-autofill:active {
              -webkit-transition-delay: 99999s;
              -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
            }
					}

					.iconfont {
						color: #22C1D3;
						font-size: 1.12rem;
					}

					.el-input__prefix {
						left: 0.6rem;
						top: 0.2rem;
					}

					.el-input__suffix {
						right: 0.6rem;
						top: 0.48rem;
					}

					.iconfont-pwd {
						cursor: pointer;
					}
				}

				.form-code {
					.el-input {
						width: calc(100% - 4.8rem);
					}

					.el-image {
						top: 0.56rem;
						left: 0.16rem;
						width: 4rem;
						height: 1.6rem;
					}

					.el-input-group__append {
						background-color: rgba(0, 0, 0, 0);
						border: none;
					}

					.identify-code {
						position: relative;
						top: 0.08rem;
						left: 0.08rem;
					}
				}

				.save-pwd{
					background: none;
					height: auto;
					margin-bottom: 0;

					.el-form-item__content{
						line-height: inherit;

						.el-checkbox__label{
							color: #FFF;
							font-size: 0.72rem;
						}
					}
				}

				.submit-item {
					background: none;
					margin-top: 0.8rem;

					.submit-btn {
						width: 100%;
						height: 2.48rem;
						background: #00E5FF;
						border-radius: 0.4rem;
						border: none;
						font-size: 1.04rem;
						font-weight: 500;
						color: #0C3151;
					}
				}
			}
		}
	}
</style>
